import { CIRCUITO_IMG } from '../../content/circuitoVisualAssets';
import { CIRCUITO_LANDING } from '../../content/circuitoLandingCopy';

type HeroCopy = typeof CIRCUITO_LANDING.hero;

export default function CircuitoHero({ copy }: { copy: HeroCopy }) {
  return (
    <section className="relative min-h-[92vh] overflow-hidden">
      <img
        src={CIRCUITO_IMG.hero}
        alt="Espaço de pausa preparado em uma unidade da rede"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-lunins-night via-lunins-night/70 to-lunins-night/25" />
      <div className="absolute inset-0 bg-gradient-to-r from-lunins-night/80 via-lunins-night/40 to-transparent" />

      <div className="relative mx-auto flex min-h-[92vh] max-w-6xl flex-col justify-end px-5 pb-16 pt-28 md:px-8 md:pb-24">
        <p className="text-[11px] font-semibold uppercase tracking-[0.42em] text-lunins-gold">
          {copy.eyebrow}
        </p>
        <h1 className="mt-5 max-w-3xl font-serif text-4xl font-medium leading-[1.08] text-lunins-cream md:text-6xl lg:text-[4.25rem]">
          O cuidado chega até onde o servidor está.
        </h1>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-lunins-cream/80 md:text-lg">
          Um circuito de pausa e autocuidado que percorre as unidades da sua Secretaria — sem tirar a equipe do
          lugar onde o dia acontece.
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-4">
          <a
            href={copy.ctaHash}
            className="inline-flex rounded-full bg-lunins-cream px-7 py-3.5 text-sm font-semibold text-lunins-ink transition hover:bg-lunins-gold"
          >
            Desenhar o circuito da rede
          </a>
          <a href="#beneficios" className="text-sm font-medium text-lunins-cream/80 underline-offset-4 hover:text-lunins-cream hover:underline">
            O que muda para a Secretaria
          </a>
        </div>
      </div>
    </section>
  );
}
